module.exports = __webpack_public_path__ + "355f8cf656f20d8085b36fb46d0109db.pdf";